var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 12.5H2.66671C2.31309 12.5 1.97395 12.3595 1.7239 12.1095C1.47385 11.8594 1.33337 11.5203 1.33337 11.1667V7.83333C1.33337 7.47971 1.47385 7.14057 1.7239 6.89052C1.97395 6.64048 2.31309 6.5 2.66671 6.5H13.3334C13.687 6.5 14.0261 6.64048 14.2762 6.89052C14.5262 7.14057 14.6667 7.47971 14.6667 7.83333V11.1667C14.6667 11.5203 14.5262 11.8594 14.2762 12.1095C14.0261 12.3595 13.687 12.5 13.3334 12.5H12",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.50001V2.50001C4 2.3232 4.07024 2.15363 4.19526 2.02861C4.32029 1.90358 4.48986 1.83334 4.66667 1.83334H11.3333C11.5101 1.83334 11.6797 1.90358 11.8047 2.02861C11.9298 2.15363 12 2.3232 12 2.50001V6.50001",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.83334H4.66667C4.29848 9.83334 4 10.1318 4 10.5V14.5C4 14.8682 4.29848 15.1667 4.66667 15.1667H11.3333C11.7015 15.1667 12 14.8682 12 14.5V10.5C12 10.1318 11.7015 9.83334 11.3333 9.83334Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.277be0d57e6bf478fcc7e4015fce56b1.svg";
export { ForwardRef as ReactComponent };